import React from 'react'

const DialogChangeLastCoordinatorError = () => {
  return (
    <p>
      Eres la única persona con este rol en tu entidad.
      <br />
      Para continuar, primero debes asignar el rol a otra persona.
    </p>
  )
}

export default DialogChangeLastCoordinatorError
